<template>
  <section style="padding:0 5%;">
    <el-form
      ref="form"
      label-position="top"
      status-icon
      :model="form"
      :rules="rules"
      label-width="100px"
      style="width:100%;"
    >
      <el-divider content-position="left">场景基本信息</el-divider>
      <el-form-item label="场景名称" prop="name" required>
        <el-input v-model="form.name" placeholder="请输入场景名称"></el-input>
      </el-form-item>
      <el-form-item label="佛像：" prop="buddhas" >
        <el-checkbox-group v-model="form.buddhas">
          <el-checkbox-button v-for="(value,index) in buddhaList" :label="value" :key="index">{{value}}</el-checkbox-button>
        </el-checkbox-group>
        <el-button icon="el-icon-plus" type="primary" plain style="margin-top: 10px;" @click="handleOpenAdd">添加</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="close('form')">取消</el-button>
        <el-button type="primary" @click="addData('form')" :plain="true">立即添加</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>

  let _this;
  let id = 0;
  import {addData} from "@/api/temple.js";
  import { getGroups} from "@/api/system.js";
  import {getAgentListSelect} from "@/api/agent.js"

  export default {
    props: {
      row: Object,
      editId: Number
    },
    components: {DistrictsCascader, UploadQiniu, Picture},
    data() {
      return {
        form: {
          name: "",
          buddhas:[]
        },
        buddhaList:[],
        id: "",
        rules: {
          "name": [
            {required: true, message: "请输入场景名称", trigger: "blur"},
          ],
        },
        innerVisible:false
      };
    },

    computed: {
    },

    mounted() {
      _this = this;
      _this.groupID = _this.$store.state.user.userData.group_id
      _this.init();

    },

    methods: {
      // 初始化数据
      init() {
      },
      handleOpenAdd(){
        // this.priceShow = true
        this.$prompt('请添加新的佛像', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          console.log(parseInt(value))
          this.form.prices.push(parseInt(value))
          this.priceList.push(parseInt(value))
          console.log(this.form.prices)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });       
        });
      },
      addData(form) {
        this.$refs[form].validate(valid => {
          if (valid) {
            addData( _this.form).then((res) => {
              if (res.code === 200) {
                _this.$message({
                  message: "添加成功",
                  type: "success"
                });
                setTimeout(() => {
                  _this.$emit("success");
                }, 1000);
              }
            });
            this.form = form
          } else {
            console.log("error submit!!");
            return false;
          }
        })
      },
    }
  };
</script>
<style lang="scss" scoped>
  .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    border: 1px dashed #ccc;
    border-radius: 50%;
    overflow: hidden;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    text-align: left !important;
  }

  .el-select-dropdown__item{
    height:auto !important;
  }
</style>
